<template>
  <div :id="componentId" class="sp2-module-1" :style="moduleStyle">
    <div class="sp2-banner-wrap" @mouseenter="stopAutoplay" @mouseleave="startAutoplay">
      <a
        v-if="currentItem && currentItem.url"
        class="sp2-banner-link"
        :href="currentItem.url"
        target="_blank"
        @click.prevent="goTo(currentItem.url)"
      >
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-banner-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-banner-placeholder">请配置轮播大图</div>
      </a>
      <div v-else class="sp2-banner-link">
        <img
          v-if="currentItem && currentItem.imageUrl"
          class="sp2-banner-image"
          referrerpolicy="no-referrer"
          :src="currentItem.imageUrl"
        />
        <div v-else class="sp2-banner-placeholder">请配置轮播大图</div>
      </div>

      <div v-if="hasMultiple" class="sp2-banner-dots">
        <span
          v-for="(item, index) in list"
          :key="index"
          :class="['sp2-dot', { active: currentIndex === index }]"
          @click.stop="goToIndex(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpTwoModule1',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_1'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      list: [
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        },
        {
          imageUrl: '',
          url: ''
        }
      ],
      currentIndex: 0,
      timer: null
    };
  },
  computed: {
    currentItem() {
      return this.list[this.currentIndex] || null;
    },
    hasMultiple() {
      return this.list.length > 1;
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    }
  },
  mounted() {
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    startAutoplay() {
      if (!this.hasMultiple) return;
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.list.length;
      }, 4000);
    },
    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    goToIndex(index) {
      if (index < 0 || index >= this.list.length) return;
      this.currentIndex = index;
      this.stopAutoplay();
      this.startAutoplay();
    },
    goTo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.sp2-module-1 {
  position: relative;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}

.sp2-banner-wrap {
  position: relative;
  width: 100%;
  height: 52vw;
  max-height: 390px;
  min-height: 180px;
  overflow: hidden;
  background: #f5f7fa;
}

.sp2-banner-link {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.sp2-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp2-banner-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  color: #909399;
  font-size: 14px;
}

.sp2-banner-dots {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 3;
}

.sp2-dot {
  width: 20px;
  height: 4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sp2-dot.active {
  width: 24px;
  background: #c00000;
}
</style>
